export const asideInfoStyle = {
  wrapper: {
    position: 'relative',
    borderRadius: '12px',
    backgroundColor: 'var(--primary-500)',
    padding: {
      xs: '12px',
      sm: '40px',
    },
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 'calc(100vh - 80px)',
  },

  backgroundIcon: {
    top: '50%',
    left: '50%',
    transform: 'translate(-20%, -50%)',
    width: '100%',
    opacity: '0.1',
    backgroundRepeat: 'no-repeat',
    height: '570px',
    position: 'absolute',
    pointerEvents: 'none',
    zIndex: 0,
  },

  logo: {},

  title: {
    maxWidth: '305px',
    width: '100%',
    marginBottom: '32px',
    color: 'var(--default-white)',
  },

  description: {
    maxWidth: '320px',
    color: 'var(--default-white)',
    opacity: '0.7',
  },

  link: {
    fontSize: '14px',
    fontWeight: 400,
    color: 'var(--default-white)',
    textDecoration: 'none',
  },

  footer: {
    display: 'flex',
    gap: {
      xs: '10px',
      md: '40px',
    },
    position: 'absolute',
    bottom: '40px',
	zIndex: 3,

    '& a:hover': {
      opacity: '0.7',
    },
  },

  centerContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    textAlign: 'start',
    zIndex: 2,
  },
};
